module.exports = __webpack_public_path__ + "img/rem4.7fa0d1a6.jpg";